import LinearGradient from "react-native-linear-gradient"
import React from "react"
import { VoucherContainerProp } from "./props"
import { style } from "./styles"
import { useColor } from "app/theme/getThemes"

import { Text } from "components/Text"
import { View, Image, TouchableOpacity } from "react-native"
import moment from "moment"
import { translate } from "i18n"
import Svg, { Line } from "react-native-svg"
import expired from "assets/expired-new.png"
import claimed from "assets/claimed-new.png"
import fullyClaimed from "assets/outofstock-new.png"
import used from "assets/used.png"
import { colors } from "colors"

export const VoucherContainerV1 = (props: VoucherContainerProp) => {
  const {
    voucherName,
    voucherPointReq,
    voucherDescription,
    voucherImg,
    voucherStartDate,
    button,
    isRedeemed,
    isExpired,
    isEmpty,
    isUsed,
    currentLocation,
    onPress,
  } = props

  const { companyTheme } = useColor()
  const today = moment()
  const startDate = moment(voucherStartDate)
  const endDate = startDate.clone().add(7, "days")
  const isSevenDayFromStart = today.isBetween(startDate, endDate, "days", "[]")

  return (
    <>
      <TouchableOpacity onPress={onPress} style={style.contentContainerV}>
        <Image
          source={{
            uri: voucherImg,
          }}
          resizeMode="cover"
          style={{
            width: 180,
            maxWidth: 180,
            height: 200,
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            borderColor: colors.border,
          }}
        />
        <View style={{ padding: 10 }}>
          <Text
            numberOfLines={1}
            style={[style.voucherTitleText, { color: colors.black, fontWeight: "normal" }]}
          >
            {voucherName}
          </Text>
          <Text numberOfLines={1} style={[style.pointText, { color: companyTheme.first }]}>
            {voucherDescription}
          </Text>
          {currentLocation === "redeem" ||
            (currentLocation === "voucherHome" && (
              <Text style={[style.pointText, { color: companyTheme.first }]}>
                {voucherPointReq?.toLocaleString() || 0} {translate("redeemScreen.pts")}
              </Text>
            ))}
        </View>

        {(isRedeemed || isExpired || isEmpty || isUsed) && (
          <Image
            source={isUsed ? used : isExpired ? expired : isRedeemed ? claimed : fullyClaimed}
            resizeMode="contain"
            style={style.expiredClaimedImage}
          />
        )}

        {button && button()}
      </TouchableOpacity>
    </>
  )
}
